import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-system-info-dialog',
  templateUrl: './system-info-dialog.component.html',
  styleUrls: ['./system-info-dialog.component.css']
})
export class SystemInfoDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<SystemInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SystemInfoDialogData
  ) {}

  close() {
    this.dialogRef.close();
  }
}

export interface SystemInfoDialogData {
  title: string;
  subTitle?: string;
  content: string;
  isHtmlContent: boolean;
}
